import { Button, styled } from '@mui/material';
import { PDFViewerViewMode } from '../PDFViewer.props';

// US Letter aspect ratio (11/8.5 ≈ 1.294) for placeholder sizing
const PAGE_ASPECT_RATIO = 1.294;

export const PdfViewerPageContainer = styled('div')<{
  $viewMode: PDFViewerViewMode;
  $isVisible: boolean;
  $isSelected: boolean;
  $width?: number;
}>(({ $viewMode, $isVisible, $isSelected, $width }) => ({
  marginBottom: '20px',
  border: $isSelected ? '3px solid #1976d2' : '1px solid #ddd',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  minHeight: (() => {
    if ($viewMode === PDFViewerViewMode.DOCUMENT && !$isVisible) {
      return $width ? `${Math.round($width * PAGE_ASPECT_RATIO)}px` : '400px';
    }
    return 'auto';
  })(),
  width: $viewMode === PDFViewerViewMode.THUMBNAIL ? $width : undefined,
  display: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'flex' : undefined,
  flexDirection: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'column' : undefined,
  opacity: 0,
  transform: 'translateY(20px) scale(0.98)',
  transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  '&.animate-in': {
    opacity: 1,
    transform: 'translateY(0) scale(1)',
  },
}));

export const PdfViewerPageHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#f8f9fa',
  padding: '8px 16px',
  borderBottom: '1px solid #ddd',
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#495057',
});

export const HighlightableTextOverlayActionButton = styled(Button)(() => ({
  position: 'fixed',
  zIndex: 9999,
  background: 'white',
  border: '1px solid #ccc',
  borderRadius: '4px',
  padding: '6px 12px',
  fontSize: '14px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  cursor: 'pointer',
  color: 'black'
}));
